<template>
  <div class="log-list">
    <logItem v-for="item in items" :key="item.workLogId" :item="item"></logItem>
  </div>
</template>
<script>
import logItem from './logItem'

export default {
  components: {
    logItem
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  }
}
</script>
<style lang="scss">
@import '../../assets/css/mixin';
.log-list {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
